<template>
  <div class='out-wrap'>
    <h3>其他信息</h3>
     <van-form ref='employess'>
       <van-field colon  v-model.trim="employees_info.qq" label="微信/QQ" placeholder="请输入个人微信或QQ"/>
       <!-- 工商银行卡号规则
        1.储蓄卡（一般为19位）：卡号以622203、621476、622202、621226、622200、955880、955881、955882等开头的卡片为灵通卡或E时代卡；以622208、621227、621288、623229、621475、621218、955888等开头的卡片为理财金卡或工银财富理财金卡。
        2.信用卡（一般为14-16位）：卡号以3、4、5、6开头（除国际借记卡外）。 -->
        <van-field required maxlength="19" type="digit" colon v-model.trim="employees_info.bank_num" clearable name="工商银行卡号" label="工资卡卡号" placeholder="请输入工商银行卡号" :rules="[{ required: true, message: '请输入工商银行卡号'},{ pattern: /^((62(2203|1476|1226|2202|2200|2208|1227|1288|3229|1475|1218)|95588[0128])\d{13}|[3456]\d{13,15})$/, message: '请输入工商银行卡号'}]"/>
        <van-field required colon v-model.trim="employees_info.open_bank_name" clearable name="开户支行" label="开户支行" placeholder="请输入开户支行网点名称" :rules="[{ required: true, message: '请输入开户支行网点名称'}]"/>
       <van-field colon required readonly clickable name="现通信住址" :value="employees_info.contact_address" label="现通信住址" placeholder="请点击选择现通信住址" @click="contact_addressPicker = true" right-icon="arrow" :rules="[{ required: true, message: '请点击选择现通信住址'}]"/>
        <van-popup v-model.trim="contact_addressPicker" position="bottom">
          <van-area :value='setJiguanAddress' :area-list="native_placeList" @confirm="pickerConfirm($event, 'contact_address', 'address')" @cancel="contact_addressPicker = false"/>
        </van-popup>
        <van-field colon required v-model.trim="employees_info.contact_place_details" clearable name="详细地址" label="详细地址" placeholder="请输入详细通讯地址" :rules="[{ required: true, message: '请输入详细通讯地址' }]"/>
        <van-field required colon v-model.trim="employees_info.emergency_contact" clearable name="紧急联系人" label="紧急联系人" placeholder="请输入紧急联系人姓名" :rules="[{ required: true, message: '请输入紧急联系人姓名'}]"/>
        <van-field required colon v-model.trim="employees_info.emergency_relationship" clearable name="关系" label="关系" placeholder="请输入与紧急联系人的关系" :rules="[{ required: true, message: '请输入与紧急联系人的关系'}]"/>
        <van-field required maxlength="11" type="tel" colon v-model.trim="employees_info.emergency_phone" clearable name="联系人电话" label="联系人电话" placeholder="请输入紧急联系人电话" :rules="[{ required: true, message: '请输入紧急联系人电话'},{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误'}]"/>
        
          <van-field colon v-model.trim="employees_info.roommate_name" label="合租人姓名" placeholder="请输入合租人姓名" />
          <van-field colon maxlength="11" type="tel" v-model.trim="employees_info.roommate_phone" label="合租人电话" placeholder="请输入合租人联系方式" />
        
      <div style="margin: 16px;">
        <van-button class='submit-btn' block type="info" @click="submitData">提交信息</van-button>
      </div> 
    </van-form>
  </div>
</template>

<script>
import { getStore, setStore } from '../../../utils/localStore';
import native_placeList from "../../../assets/js/area";

export default {
  data() {
    return {
      employees_info: {
        emergency_contact: '',
        emergency_relationship: '',
        emergency_phone: ''
      },
      contact_addressPicker: false,
      setJiguanAddress: "440106",
      native_placeList,
    }
  },
  mounted() {
    this.$nextTick(() => {
      let data = getStore({name: 'applyInfo'});
      if(data) this.employeesInit(data);
      let employessInfo = getStore({name: 'employeesInfo'})
      if(employessInfo){
        this.employees_info = employessInfo;
      }
    })
    
  },
  beforeRouteLeave(to, from, next){
      setStore({
          name: 'employeesInfo',
          content: this.employees_info,
          options: {
            expiry: '2h'
          }
      })
    next()  
  },
  methods: {
    employeesInit(data) {
      this.employees_info.emergency_contact = data.emergency_contact;
      this.employees_info.emergency_relationship = data.emergency_type;
      this.employees_info.emergency_phone = data.emergency_phone;
    },
    pickerConfirm(val,type,spec='') { //统一方法替换
      if(spec){
        let str = ''
        _.map(val, item => {
          str += item.name+'/'
        })
        this.employees_info[type] = str;
      }else{
        this.employees_info[type] = !val.v ? moment(val).format('YYYY-MM-DD') : val.v;
      }
      let picker = type+'Picker'
      this[picker] = false;
    },
    submitData() {
      this.$refs.employess.validate().then(res => {
        setStore({
          name: 'employeesInfo',
          content: this.employees_info,
          options: {
            expiry: '2h'
          }
        })
        this.$emit('submitdata')
      }).catch( err => {
        this.$toast({
            message: `请填写${err[0].name}`,
            duration: 2500
          })
          return
      })
    }
  }

}
</script>

<style lang='less' scoped>
@import "../../../assets/css/page.css";
@import "../../../assets/css/wrap.css";
</style>